import { PropsWithChildren, useState, useMemo } from 'react';
import { NavButtonContext } from './useNavButton';

export function NavButtonProvider({
  children,
  initialExpanded = false,
}: PropsWithChildren<{ initialExpanded?: boolean }>) {
  const [expanded, setExpanded] = useState(initialExpanded);

  const value = useMemo(
    () => ({
      expanded,
      setExpanded,
      toggleExpanded: () => setExpanded((prev) => !prev),
    }),
    [expanded],
  );

  return <NavButtonContext.Provider value={value}>{children}</NavButtonContext.Provider>;
}
